module.exports = require("react-bootstrap/Tab");